import { defineMessages } from 'react-intl-next';

export const messages: {
	moreButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	moreButton: {
		id: 'company-hub.search-extension.more-button',
		defaultMessage: 'View more results',
		description:
			'Text for the more button in the search dialog footer. When clicked, users will be redirected to the advanced search page.',
	},
});
